
// import React from 'react'
// import { motion } from 'framer-motion'
// import privacy from "../assets/privacypolicy.jpg"

// export const Privacypolicy = () => {
//   return (
//     <div className="w-full">

//       {/* 1. HERO SECTION */}
//       <div className="relative w-full h-[40vh] md:h-[70vh] overflow-hidden flex items-center justify-center">

//         {/* BACKGROUND IMAGE LAYER (Blurred & Animated) */}
//         <motion.img 
//           src={privacy}
//           alt="Privacy Policy Background"
//           initial={{ opacity: 0, scale: 1.1 }}
//           animate={{ opacity: 1, scale: 1 }}
//           transition={{ duration: 1.2, ease: "easeOut" }}
//           // BLUR is applied ONLY to the image here
//           className="absolute inset-0 w-full h-full object-cover object-center blur-[2px]"
//         />

//         {/* DARK OVERLAY LAYER (To make white text pop) */}
//         <div className="absolute inset-0 bg-black/40"></div>

//         {/* TEXT LAYER (Sharp, Centered, No Blur) */}
//        <div className="relative z-10 text-center px-4">

//   {/* Wrapper div with overflow-hidden creates the "Slider/Mask" effect */}
//   <div className="overflow-hidden pb-2">
//     <motion.h1 
//       initial={{ y: "100%" }}
//       animate={{ y: 0 }}
//       transition={{ ease: [0.22, 1, 0.36, 1], duration: 1.2 }} 
//       className="text-4xl md:text-6xl font-bold tracking-wide"
//     >

//       <span className="bg-clip-text text-transparent bg-gradient-to-br from-[#F46653] via-[#ff9b8e] to-white drop-shadow-[0_4px_4px_rgba(12,69,80,0.5)]">
//         Privacy Policy
//       </span>
//     </motion.h1>
//   </div>

//   {/* Wrapper for the subtitle slider */}
//   <div className="overflow-hidden">
//     <motion.p 
//       initial={{ y: "100%" }}
//       animate={{ y: 0 }}
//       transition={{ delay: 0.2, ease: [0.22, 1, 0.36, 1], duration: 1.2 }}
//       className="mt-4 text-xs md:text-sm uppercase tracking-widest font-medium text-gray-100"
//     >
//       {/* Added a subtle text shadow using the Teal color for consistency */}
//       <span style={{ textShadow: '0 2px 10px #0C4550' }}>
//          Last Updated: December 2025 
//       </span>
//     </motion.p>
//   </div>

// </div>
//       </div>

//       {/* 2. EXTENDED CONTENT SECTIONS */}
//       <div className="bg-white text-gray-800 py-12 px-6 md:py-24 md:px-16 lg:px-32">
//         <div className="max-w-4xl mx-auto space-y-12 md:space-y-20">

//           {/* Note: I removed the Heading from here since it is now in the Hero Image above */}

//           {/* Section 1 */}
//           <section>
//             <h2 className="text-xl md:text-2xl font-bold mb-4 text-gray-900">1. Introduction</h2>
//             <p className="text-base md:text-lg leading-relaxed text-gray-600">
//               Welcome to our Bulk SMS platform. We are committed to protecting your personal information and your right to privacy. This policy outlines how we handle the data you provide to us when using our SMS transmission services.
//             </p>
//           </section>

//           {/* Section 2 */}
//           <section>
//             <h2 className="text-xl md:text-2xl font-bold mb-4 text-gray-900">2. Information We Collect</h2>
//             <p className="text-base md:text-lg leading-relaxed text-gray-600">
//               We collect personal details such as your name, email address, and phone number upon registration. Additionally, we process data you upload for SMS campaigns, including contact lists (mobile numbers), message content (templates), and sender IDs.
//             </p>
//           </section>

//           {/* Section 3 */}
//           <section>
//             <h2 className="text-xl md:text-2xl font-bold mb-4 text-gray-900">3. Use of Your Information</h2>
//             <p className="text-base md:text-lg leading-relaxed text-gray-600">
//               Your data is used primarily to facilitate the transmission of SMS messages to intended recipients. We also use your information to manage your account, process billing transactions, and provide technical support regarding delivery reports.
//             </p>
//           </section>

//           {/* Section 4 */}
//           <section>
//             <h2 className="text-xl md:text-2xl font-bold mb-4 text-gray-900">4. Data Sharing & Third Parties</h2>
//             <p className="text-base md:text-lg leading-relaxed text-gray-600">
//               We do not sell your data. However, to deliver SMS messages, we must transmit message content and recipient numbers to telecommunication operators and network providers. These transfers are strictly for the purpose of message delivery.
//             </p>
//           </section>

//           {/* Section 5 */}
//           <section>
//             <h2 className="text-xl md:text-2xl font-bold mb-4 text-gray-900">5. Data Security</h2>
//             <p className="text-base md:text-lg leading-relaxed text-gray-600">
//               We implement robust security measures, including SSL encryption and secure server infrastructure, to protect your uploaded databases. Access to sensitive data is restricted to authorized personnel only.
//             </p>
//           </section>

//           {/* Section 6 */}
//           <section>
//             <h2 className="text-xl md:text-2xl font-bold mb-4 text-gray-900">6. User Responsibilities (Anti-Spam)</h2>
//             <p className="text-base md:text-lg leading-relaxed text-gray-600">
//               Users agree to use our platform in compliance with local regulations. You must have consent from recipients before sending promotional SMS. We reserve the right to suspend accounts found sending unsolicited spam or fraudulent messages.
//             </p>
//           </section>

//           {/* Section 7 */}
//           <section>
//             <h2 className="text-xl md:text-2xl font-bold mb-4 text-gray-900">7. Cookies and Tracking</h2>
//             <p className="text-base md:text-lg leading-relaxed text-gray-600">
//               Our website uses cookies to enhance user experience, remember your login session, and analyze website traffic. You can choose to disable cookies through your browser settings, though this may affect platform functionality.
//             </p>
//           </section>

//           {/* Section 8 */}
//           <section>
//             <h2 className="text-xl md:text-2xl font-bold mb-4 text-gray-900">8. Data Retention</h2>
//             <p className="text-base md:text-lg leading-relaxed text-gray-600">
//               We retain your account information for as long as your account is active. Message logs and delivery reports are retained for a specific period to assist with disputes or audits, after which they are anonymized or deleted.
//             </p>
//           </section>

//           {/* Section 9 */}
//           <section>
//             <h2 className="text-xl md:text-2xl font-bold mb-4 text-gray-900">9. Your Rights</h2>
//             <p className="text-base md:text-lg leading-relaxed text-gray-600">
//               You have the right to request access to the personal data we hold about you. You may also request corrections to your profile or the deletion of your account and associated data, subject to legal retention requirements.
//             </p>
//           </section>

//           {/* Section 10 */}
//           <section>
//             <h2 className="text-xl md:text-2xl font-bold mb-4 text-gray-900">10. Contact Us</h2>
//             <p className="text-base md:text-lg leading-relaxed text-gray-600">
//               If you have questions regarding this Privacy Policy or your data, please contact our support team. We are committed to resolving any privacy concerns promptly.
//             </p>
//           </section>

//         </div>
//       </div>

//     </div>
//   )
// }





import React, { useState, useEffect, useRef } from 'react';
import { motion } from 'framer-motion';
// Ensure this path is correct in your project
import privacy from "../assets/privacypolicy.webp";

// --- Data for the Privacy Policy Sections ---
const policySections = [
  {
    id: "intro",
    title: "1. Introduction",
    content: (
      <>
        <p>
          Welcome to our Bulk SMS platform. We take your privacy seriously. This Privacy Policy outlines how we collect, use, process, and protect your personal information and the data you upload for messaging campaigns. By using our services, API, or web interface, you agree to the practices described in this policy.
        </p>
        <p className="mt-4">
          This policy applies to all users, including enterprise clients, resellers, and developers integrating our SMS APIs.
        </p>
      </>
    )
  },
  {
    id: "collection",
    title: "2. Information We Collect",
    content: (
      <>
        <p>We collect various types of information to provide and improve our SMS delivery services:</p>
        <ul className="list-disc ml-5 mt-3 space-y-2">
          <li><strong>Account Information:</strong> Name, email address, phone number, company name, and billing details provided during registration.</li>
          <li><strong>uploaded Data:</strong> Contact lists (mobile numbers), message templates, sender IDs, and variables uploaded for SMS campaigns.</li>
          <li><strong>Traffic Data:</strong> Logs of sent messages, delivery status reports (DLRs), timestamps, and network routing information.</li>
          <li><strong>Technical Data:</strong> IP addresses, browser types, and API access logs for security and auditing purposes.</li>
        </ul>
      </>
    )
  },
  {
    id: "usage",
    title: "3. How We Use Your Information",
    content: (
      <>
        <p>Your data is utilized primarily to facilitate the transmission of SMS messages. Specifically, we use it to:</p>
        <ul className="list-disc ml-5 mt-3 space-y-2">
          <li>Route messages to telecommunication operators and aggregators for final delivery.</li>
          <li>Authenticate your access to our dashboard and API endpoints.</li>
          <li>Generate delivery reports and analytics for your campaigns.</li>
          <li>Process billing, invoices, and credit top-ups.</li>
          <li>Comply with local regulatory bodies (e.g., TRAI, DLT platforms) regarding commercial communication.</li>
        </ul>
      </>
    )
  },
  {
    id: "sharing",
    title: "4. Data Sharing & Third Parties",
    content: (
      <>
        <p>
          We do not sell your personal data or your uploaded contact lists to third parties for marketing purposes. However, the nature of SMS transmission requires specific data sharing:
        </p>
        <div className="bg-gray-50 border-l-4 border-[#F46653] p-4 my-4">
          <p className="font-medium text-gray-800">Telecommunication Operators:</p>
          <p className="text-sm mt-1">
            Message content and recipient phone numbers must be transmitted to network operators (e.g., Vodafone, Jio, Airtel, global carriers) to effect delivery. These operators process data in accordance with their own regulatory licenses.
          </p>
        </div>
        <p>
          We may also share data with legal authorities if required by law, such as in the investigation of fraud or abusive messaging.
        </p>
      </>
    )
  },
  {
    id: "security",
    title: "5. Data Security & Encryption",
    content: (
      <>
        <p>
          We employ industry-standard security measures to protect your data:
        </p>
        <ul className="list-disc ml-5 mt-3 space-y-2">
          <li><strong>Encryption:</strong> All data in transit is encrypted via SSL/TLS protocols. Sensitive databases are encrypted at rest.</li>
          <li><strong>Access Control:</strong> Strict role-based access controls limit which employees can view system logs.</li>
          <li><strong>API Security:</strong> We use token-based authentication (API Keys) to secure programmatic access. Users are responsible for keeping their API keys confidential.</li>
        </ul>
      </>
    )
  },
  {
    id: "spam",
    title: "6. Anti-Spam & Compliance",
    content: (
      <>
        <p>
          Our platform maintains a zero-tolerance policy towards spam. Users must ensure that:
        </p>
        <ul className="list-disc ml-5 mt-3 space-y-2">
          <li>All recipients have opted-in to receive messages (Opt-in Compliance).</li>
          <li>Marketing messages contain valid opt-out instructions where required by law.</li>
          <li>Content does not violate local regulations (e.g., DLT registration in India, GDPR in Europe, TCPA in the US).</li>
        </ul>
        <p className="mt-3 text-red-500 font-medium">
          Accounts found sending phishing links, fraudulent content, or unsolicited spam will be suspended immediately without refund.
        </p>
      </>
    )
  },
  {
    id: "cookies",
    title: "7. Cookies & Technologies",
    content: (
      <>
        <p>
          We use cookies to maintain your session security and analyze platform performance. These include:
        </p>
        <ul className="list-disc ml-5 mt-3 space-y-2">
          <li><strong>Essential Cookies:</strong> Required for logging in and navigating the dashboard.</li>
          <li><strong>Analytics Cookies:</strong> Help us understand usage patterns to optimize our infrastructure.</li>
        </ul>
        <p className="mt-3">
          You can control cookie preferences via your browser settings, though disabling them may impact your ability to use the dashboard.
        </p>
      </>
    )
  },
  {
    id: "retention",
    title: "8. Data Retention Policy",
    content: (
      <>
        <p>
          We retain your account information as long as your account is active. Specific retention periods apply to message logs:
        </p>
        <ul className="list-disc ml-5 mt-3 space-y-2">
          <li><strong>Message Logs:</strong> Retained for 13 months to assist with delivery disputes, auditing, and legal compliance.</li>
          <li><strong>Uploaded Lists:</strong> Stored until deleted by the user or upon account termination.</li>
        </ul>
        <p className="mt-3">
          After the retention period, data is either anonymized or securely deleted from our servers.
        </p>
      </>
    )
  },
  {
    id: "rights",
    title: "9. Your Rights",
    content: (
      <>
        <p>
          Subject to applicable laws, you have the right to:
        </p>
        <ul className="list-disc ml-5 mt-3 space-y-2">
          <li>Access the personal data we hold about you.</li>
          <li>Request correction of inaccurate data.</li>
          <li>Request deletion of your account and data (Right to be Forgotten), provided no legal obligation requires us to keep it (e.g., telecom regulations).</li>
          <li>Export your contact lists and reports before closing your account.</li>
        </ul>
      </>
    )
  },
  {
    id: "contact",
    title: "10. Contact Us",
    content: (
      <>
        <p>
          If you have any questions, concerns, or disputes regarding this Privacy Policy, please send an e-mail to:
        </p>
        <div className="mt-4 p-4 bg-orange-50 rounded-lg border border-[#0C4550]/20">
          <p><strong>Email:</strong>  info@deetyasoft.com</p>
          <p><strong>Address:</strong> Abhay Khand-2, Indirapuram,
            Ghaziabad, Uttar Pradesh-
            201014</p>
        </div>
      </>
    )
  }
];

export const Privacypolicy = () => {
  const [activeSection, setActiveSection] = useState("intro");

  // Refs for scroll observation
  const sectionRefs = useRef({});
  const sidebarRef = useRef(null);

  // Scroll Spy Logic
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setActiveSection(entry.target.id);
          }
        });
      },
      {
        rootMargin: "-20% 0px -60% 0px", // Triggers when section is near top of viewport
        threshold: 0
      }
    );

    Object.values(sectionRefs.current).forEach((section) => {
      if (section) observer.observe(section);
    });

    return () => observer.disconnect();
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      // Offset for sticky header if you have one, plus a little breathing room
      const offset = 80;
      const bodyRect = document.body.getBoundingClientRect().top;
      const elementRect = element.getBoundingClientRect().top;
      const elementPosition = elementRect - bodyRect;
      const offsetPosition = elementPosition - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth"
      });
      setActiveSection(id);
    }
  };

  return (
    <div className="w-full bg-white">

      {/* 1. HERO SECTION (Unchanged as requested) */}
      <div className="relative w-full h-[40vh] md:h-[70vh] overflow-hidden flex items-center justify-center">

        {/* BACKGROUND IMAGE */}
        <motion.img
          src={privacy}
          alt="Privacy Policy Background"
          initial={{ opacity: 0, scale: 1.1 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 1.2, ease: "easeOut" }}
          className="absolute inset-0 w-full h-full object-cover object-center blur-[3px]"
        />

        {/* DARK OVERLAY */}
        <div className="absolute inset-0 bg-black/40"></div>

        {/* TEXT CONTENT */}
        <div className="relative z-10 text-center px-4">
          <div className="overflow-hidden pb-2">
            <motion.h1
              initial={{ y: "100%" }}
              animate={{ y: 0 }}
              transition={{ ease: [0.22, 1, 0.36, 1], duration: 1.2 }}
              className="text-4xl md:text-6xl font-bold tracking-wide"
            >
              <span className="bg-clip-text text-transparent bg-gradient-to-br from-[#F46653] via-[#ff9b8e] to-white drop-shadow-[0_4px_4px_rgba(12,69,80,0.5)]">
                Privacy Policy
              </span>
            </motion.h1>
          </div>

          <div className="overflow-hidden">
            <motion.p
              initial={{ y: "100%" }}
              animate={{ y: 0 }}
              transition={{ delay: 0.2, ease: [0.22, 1, 0.36, 1], duration: 1.2 }}
              className="mt-4 text-sm md:text-sm uppercase tracking-widest font-medium text-white"
            >
              <span style={{ textShadow: '0 2px 10px #0C4550' }}>
                Last Updated: December 2025
              </span>
            </motion.p>
          </div>
        </div>
      </div>

      {/* 2. MAIN CONTENT AREA - Sidebar & Content */}
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16 pb-24">

        <div className="flex flex-col lg:flex-row gap-12">

          {/* --- LEFT SIDE: STICKY TABLE OF CONTENTS --- */}
          <aside className="lg:w-1/4 hidden lg:block">
            <div className="sticky top-24 pt-8 border-r border-gray-200 pr-6">
              <h3 className="text-sm font-bold text-gray-700 uppercase tracking-wider mb-6">
                Table of Contents
              </h3>
              <nav className="space-y-1 relative">
                {policySections.map((section) => (
                  <button
                    key={section.id}
                    onClick={() => scrollToSection(section.id)}
                    className={`
    group flex items-center px-4 py-3 text-sm font-medium rounded-xl transition-all duration-200 ease-in-out
    ${activeSection === section.id
                        ? 'bg-[#0C4550]/10 text-[#0C4550] shadow-sm ring-1 ring-[#0C4550]/20'
                        : 'text-gray-600 hover:bg-gray-50 hover:text-[#0C4550]'
                      }
`}
                  >
                    <span>{section.title}</span>
                    {/* {activeSection === section.id && (
                      <motion.div
                        layoutId="active-pill"
                        className="w-1.5 h-1.5 rounded-full bg-[#F46653]"
                      />
                    )} */}
                  </button>
                ))}
              </nav>
            </div>
          </aside>

          {/* --- MOBILE CONTENTS DROPDOWN (Visible only on small screens) --- */}
          <div className="lg:hidden mt-8">
            <details className="bg-gray-50 rounded-lg p-4 border border-gray-200">
              <summary className="font-bold text-gray-800 cursor-pointer">Table of Contents</summary>
              <nav className="mt-4 flex flex-col space-y-2">
                {policySections.map((section) => (
                  <button
                    key={section.id}
                    onClick={() => scrollToSection(section.id)}
                    className="text-left text-sm text-gray-600 py-1 hover:text-[#F46653]"
                  >
                    {section.title}
                  </button>
                ))}
              </nav>
            </details>
          </div>

          {/* --- RIGHT SIDE: CONTENT SECTIONS --- */}
          <main className="lg:w-3/4 pt-8 lg:pt-8">
            <div className="space-y-16">
              {policySections.map((section) => (
                <section
                  key={section.id}
                  id={section.id}
                  ref={(el) => (sectionRefs.current[section.id] = el)}
                  className="scroll-mt-24"
                >
                  <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-100px" }}
                    transition={{ duration: 0.5 }}
                  >
                    <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-6 border-b border-gray-100 pb-4">
                      {section.title}
                    </h2>
                    <div className="text-gray-600 text-base md:text-lg leading-relaxed space-y-4 text-justify">
                      {section.content}
                    </div>
                  </motion.div>
                </section>
              ))}
            </div>

            {/* Footer note inside content area */}
            <div className="mt-20 pt-8 border-t border-gray-200 text-sm text-gray-500 text-center">
              &copy; {new Date().getFullYear()} Eurofox Bulk SMS Service. All rights reserved.
            </div>
          </main>

        </div>
      </div>

    </div>
  );
};

export default Privacypolicy;